import { api } from '../lib/api';
import { CodeForm } from './code-form';

// a new admin session: enter the code from the app (or a recovery code) to continue
export function TwoStepVerify({ onDone, onSignOut }: { onDone: () => void; onSignOut: () => void }) {
  return (
    <div className="two-step-card">
      <h1>Two-step login</h1>
      <p className="admin-muted">Open your authenticator app and enter the code for London Life.</p>
      <CodeForm
        submitLabel="Continue"
        onSubmit={async (body) => {
          await api.admin.twoStep.verify(body);
          onDone();
        }}
      />
      <button type="button" className="two-step-switch" onClick={onSignOut}>
        Sign out
      </button>
    </div>
  );
}
